import React from 'react';
import { Spinner, Flex } from '@chakra-ui/react';

export interface LoadingProps {
  /**
   * Size of the indicator.
   * Chakra UI Spinner sizes: 'sm', 'md', 'lg', 'xl'
   */
  size?: 'sm' | 'md' | 'lg' | 'xl';
  /**
   * The color of the loading indicator.
   */
  color?: string;
  /**
   * How much space the loading indicator should take around it (height).
   */
  height?: number;
}

/**
 * Loading component used across the majority of components.
 */
export const Loading = (props: LoadingProps) => {

  return (
    <Flex
    height="100vh" 
    align="center" 
    justify="center" 
  >
    <Spinner
      thickness="4px"
      speed="0.65s"
      emptyColor="gray.200"
      color="#B92F2F"
      size="xl"
    />
  </Flex>
  );
};


